<template>
    <div>
        <vx-card>
            <!-- Vehicle Counts -->
            <div class="vx-row m-0 pb-5 mb-5  shadow">
                <div class="vx-col w-full mb-2">
                    <label class="">Year to date Totals for:</label>
                </div>
                <!-- Total Trips -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_trips ? total_trips : 0}}</h6>
                            <span>Trips</span>
                        </div>
                        <feather-icon icon="UserIcon" class="p-3 inline-flex rounded-full text-success" :style="{background: `rgba(var(--vs-success),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Distance -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_distances | validNumber }} Km</h6>
                            <span>Distance</span>
                        </div>
                        <feather-icon icon="TrendingUpIcon" class="p-3 inline-flex rounded-full text-info" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Time -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_time | convertHoursMinutes }}</h6>
                            <span>Time</span>
                        </div>
                        <feather-icon icon="BoxIcon" class="p-3 inline-flex rounded-full text-warning" :style="{background: `rgba(var(--vs-warning),.10)`}"></feather-icon>
                    </div>
                </div>
                <!-- Total Fuel Amount -->
                <div class="vx-col md:w-1/4 justify-center">
                    <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                        <div class="ml-3 text-center">
                            <h6 class="mb-1 font-bold">{{ total_fuel_amount ? total_fuel_amount : 0}}</h6>
                            <span>Faults</span>
                        </div>
                        <feather-icon icon="XIcon" class="p-3 inline-flex rounded-full text-danger" :style="{background: `rgba(var(--vs-danger),.10)`}"></feather-icon>
                    </div>
                </div>
            </div>
            <!-- Filters -->
            <form class="w-full mt-6 mb-1" autocomplete="off" data-vv-scope="filter-form">
                <div class="vx-row">
					
					<div class="vx-col sm:w-1/4 w-full mb-2">
						<label for class="vs-input--label">Start Date</label>
                        <flat-pickr
                        :config="configStartDate"
                        @on-change="onStartDateChange"
                        class="vs-inputx vs-input--input normal time"
                        label="Start Date"
                        v-validate="end_date ? 'required' : ''"
                        name="start_date"
                        v-model="start_date"
                        autocomplete="off"
                        placeholder="Select Start Date"
                        />
                        <span class="text-danger text-sm">{{ errors.first('filter-form.start_date') }}</span>
					</div>
                    <div class="vx-col sm:w-1/4 w-full mb-2">
                        <label for class="vs-input--label">End Date</label>
                        <flat-pickr
                        :config="configEndDate"
                        class="vs-inputx vs-input--input normal time"
                        label="End Date"
                        v-validate="start_date ? 'required' : ''"
                        name="end_date"
                        v-model="end_date"
                        autocomplete="off"
                        placeholder="Select End Date"
                        @on-change="onEndDateChange"
                        />
                        <span class="text-danger text-sm">{{ errors.first('filter-form.end_date') }}</span>
					</div>
                    <div class="vx-col sm:w-1/4 w-full mb-2 inline-flex">
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-search" title="Search" @click.prevent="filterHistory()"></vs-button>
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-download" title="Export CSV" @click.prevent="filterHistory('export_csv')"></vs-button>
                        <vs-button class="mr-3 mt-6" type="filled" icon-pack="feather" icon="icon-file-text" title="Export PDF" @click.prevent="filterHistory('export_pdf')"></vs-button>
                        <vs-button class="mt-6" color="warning" type="filled" icon-pack="feather" icon="icon-x" title="Clear" @click.prevent="clearFilter()"></vs-button>
					</div>
				</div>
            </form>
            
            <div class="w-full m-0">
                <vs-table :data="history">
                    <template slot="thead">
                        <!-- <vs-th> </vs-th> -->
                        <vs-th> Date </vs-th>
                        <vs-th> Id </vs-th>
                        <vs-th> Vehicle </vs-th>
                        <vs-th> Odometer Start </vs-th>
                        <vs-th> Odometer End </vs-th>
                        <vs-th> Odometer Total </vs-th>
                        <vs-th> Time Start </vs-th>
                        <vs-th> Time End </vs-th>
                        <vs-th> Time Total </vs-th>
                        <vs-th> Fuel Odometer  </vs-th>
                        <vs-th> Fuel Volume </vs-th>
                        <vs-th> Fuel Value</vs-th>
                        <vs-th> Faults </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                            <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}</vs-td>
                            <vs-td>{{ tr.vehical_id ? tr.vehical_id.vehical_id : '-' }}</vs-td>
                            <vs-td>{{ tr.vehical_id ? (tr.vehical_id.name+' '+tr.vehical_id.brand) : '-' }}</vs-td>
                            <vs-td>{{ tr.start_km }}</vs-td>
                            <vs-td>{{ tr.end_km  }}</vs-td>
                            <vs-td>{{ (tr.end_km - tr.start_km) }}</vs-td>
                            <vs-td>{{ tr.start_time ? tr.start_time : '-' | moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }}</vs-td>
                            <vs-td>{{ tr.end_time ? tr.end_time : '-' | moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }}</vs-td>
                            <vs-td>{{ tr.diffrence_in_miliseconds | convertHoursMinutes}}</vs-td>
                            <vs-td>{{ tr.fuelData && tr.fuelData.receipt_no ? tr.fuelData.receipt_no : '-' }}</vs-td>
                            <vs-td>{{ tr.fuelData && tr.fuelData.quantity ? tr.fuelData.quantity : 0 }}</vs-td>
                            <vs-td>${{ tr.fuelData && tr.fuelData.amount ? tr.fuelData.amount.toFixed(2) : 0.00 }}</vs-td>
                            <vs-td>{{ tr.faultData ? tr.faultData.fault_type : '-' }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <div style="height:50px;" v-if="history.length">
                    <div class="float-right mt-2">
                        <vs-pagination ref="pagination2" :total="total_page" v-model="current_page"></vs-pagination>
                    </div>
                </div>
            </div>

            
        </vx-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    vSelect,
    Datepicker
  },
  data() {
    return {
        user_list: [],
        filter_driver_id: null,
        per_page: 10, 
        total_page: 1, 
        current_page: 1,
        vehicle_detail: {},
        total_trips: 0,
        total_distances: 0,
        total_time: 0,
        total_fuel_amount: 0,
        history: [],
        start_date: null,
        end_date: null,
        configStartDate: {
            minDate: null,
            maxDate: new Date(),
            dateFormat: "d/m/Y"
        },
        configEndDate: {
            maxDate: new Date(),
            dateFormat: "d/m/Y"
        },
    };
  },
  watch: {
    current_page(nv) {
      if (nv) {
        this.getVechicleHistory();
      }
    },
    filter_driver_id(nv){
        // this.getVechicleHistory(nv);
    }
  },
  created() {
  },
  mounted() {
    // this.getAllUsers();
    this.getVechicleHistory();
  },
  computed: {
  },
  methods: {
    /** Change start & end date configration */
    onStartDateChange(selectedDates, dateStr, instance) {
      this.$set(this.configEndDate, "minDate", dateStr);
    },
    onEndDateChange(selectedDates, dateStr, instance) {
      this.$set(this.configStartDate, "maxDate", dateStr);
    },
    /** Get all Office */
    async getAllUsers() {
        this.$vs.loading({ color: "primary" });

        let url = "user/getUsers";
        let input = {
            type: 'U',
        };
        let response_data = await this.axios
                            .get(url,{ params: input })
                            .then(response => {
                                let users = [];
                                response.data.data.forEach(element => {
                                    users.push({id:element.id, name:element.firstname+' '+element.lastname});
                                });
                                this.$vs.loading.close();
                                return users;
                            })
                            .catch(e => {
                                this.showError(e);
                            });
        if (response_data) {
            this.user_list = response_data;
        }
    },
    /** Filter vehicle data */
    filterHistory(export_data = false) {
      this.$validator.validateAll("filter-form").then(result => {
        if (result) {
            if (export_data == 'export_pdf') {
                let url = process.env.VUE_APP_API_URL + "/personalUserHistory?pdf=true";
                if (this.$store.state.uInfo.id) {
                    url += "&user_id="+this.$store.state.uInfo.id+"&login_id="+this.$store.state.uInfo.id;
                }
                if (this.start_date && this.end_date) {
                    url += "&from_time="+this.start_date+"&to_time="+this.end_date;
                }
                window.open(url,"_blank");
            }else{
                this.getVechicleHistory(export_data,this.start_date,this.end_date);
            }
        }
      });
    },
    /** Clear filter */
    clearFilter(){
        this.$validator.reset("filter-form");
        this.errors.clear("filter-form");
        this.filter_driver_id = null;
        this.start_date = null;
        this.end_date = null;
        this.getVechicleHistory();
    },
    /** Get vehicle history */
    async getVechicleHistory(export_data = false, start_date = null, end_date = null) {
        this.$vs.loading({ color: "primary" });
        let input = {
            user_id: this.$store.state.uInfo.id,
            login_id: this.$store.state.uInfo.id,
            from_time: start_date,
            to_time: end_date
        };

        if (export_data == 'export_csv') { // check export flag
            let export_input = {
                csv : true,
            }
            input = Object.assign(export_input,input);
        }
        else{ // pass pagination params for listing
            let pagination = {
                pageNo: this.current_page - 1,
                pageLimit: this.per_page
            }
            input = Object.assign(pagination,input);
        }

        let url = "personalUserHistory";
        let response_data = await this.axios
                .get(url,{ params: input })
                .then(response => {
                    if (export_data == 'export_csv') {
                        let file_name = 'vehicle-history.csv';
                        if (this.vehicle_detail && this.vehicle_detail.number) {
                           file_name = this.vehicle_detail.number+'.csv'
                        }

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", file_name);
                        document.body.appendChild(link);
                        link.click();

                        this.$vs.loading.close();
                        return false;
                    }else{
                       this.$vs.loading.close();
                       return response.data.data;
                    }
                    
                })
                .catch(e => {
                    this.showError(e);
                    return null
                });

        
        if (response_data) {
            this.total_trips = response_data.totalTrip || 0;
            this.total_distances = response_data.totalDistance || 0;
            this.total_time = response_data.totalTime || 0;
            this.total_fuel_amount = response_data.totalFuel.toFixed(2) || 0;
            this.history = response_data.data || [];
            this.total_page = response_data.pages;  
        }
        // show vehicle history
        this.show_vehicle_history = true;         
    },
  }
};
</script>

		